// extracted by mini-css-extract-plugin
export var cell = "_5t-4";
export var headerCell = "_5t-2";
export var rowHeader = "_5t-3";
export var table = "_5t-1";
export var tableContainer = "_5t-0";